export class Command {
    constructor(description) {
        this._description = description || ' ';
    }
    get description() {
        return this._description;
    }
    redo() {
        return this.do();
    }
    get itemsAffected() {
        return [];
    }
    getData() {
        return {
            id: this.id
        };
    }
}
export var CommandData;
(function (CommandData) {
    function is(arg) {
        return !!arg
            && 'id' in arg;
    }
    CommandData.is = is;
})(CommandData || (CommandData = {}));
//# sourceMappingURL=command.js.map